import ArticleOrderedContentList from './articleOrderedContentList'

const articleOrderedContentList = new ArticleOrderedContentList()
articleOrderedContentList.init()
